import {IExchangeRate} from '../models/Price';

export const FETCH_EXCHANGE_RATE = 'FETCH_EXCHANGE_RATE';
export const FETCH_EXCHANGE_RATE_SUCCESS = 'FETCH_EXCHANGE_RATE_SUCCESS';
export const FETCH_EXCHANGE_RATE_ERROR = 'FETCH_EXCHANGE_RATE_ERROR';

export interface FetchExchangeRate {
  type: typeof FETCH_EXCHANGE_RATE;
}

export interface FetchExchangeRateSuccess {
  type: typeof FETCH_EXCHANGE_RATE_SUCCESS;
  payload: IExchangeRate;
}

export interface FetchExchangeRateError {
  type: typeof FETCH_EXCHANGE_RATE_ERROR;
}

export type ExchangeRateActionTypes =
  | FetchExchangeRate
  | FetchExchangeRateSuccess
  | FetchExchangeRateError;
